var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guide" }, [
    _vm.step === 1
      ? _c("div", { staticClass: "guide-step-1" }, [
          _c("div", { staticClass: "upgrade-notes" }, [
            _c("i", {
              staticClass: "el-icon-close",
              on: { click: _vm.handleClose }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "upgrade-notes-title" }, [
              _c("svg", { staticClass: "icon" }, [
                _c("use", { attrs: { "xlink:href": "#icon-upgrade" } })
              ]),
              _vm._v("控制台新版本升级\n      ")
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "next-btn",
                on: {
                  click: function($event) {
                    _vm.step = 2
                  }
                }
              },
              [_vm._v("马上体验新版控制台")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step === 2
      ? _c("div", { staticClass: "guide-step-2" }, [
          _c("div", { staticClass: "sidebar-mask" }),
          _vm._v(" "),
          _c("div", { staticClass: "next-card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "next-btn",
                on: {
                  click: function($event) {
                    _vm.step = 3
                  }
                }
              },
              [_vm._v("\n        下一步\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-close",
            on: { click: _vm.handleClose }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step === 3
      ? _c("div", { staticClass: "guide-step-3" }, [
          _c("div", { staticClass: "navbar-mask" }),
          _vm._v(" "),
          _c("div", { staticClass: "next-card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "next-btn",
                on: {
                  click: function($event) {
                    _vm.step = 4
                  }
                }
              },
              [_vm._v("\n        下一步\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-close",
            on: { click: _vm.handleClose }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step === 4
      ? _c("div", { staticClass: "guide-step-4" }, [
          _c("div", { staticClass: "service-mask" }),
          _vm._v(" "),
          _c("div", { staticClass: "next-card" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "next-btn",
                on: {
                  click: function($event) {
                    _vm.step = 5
                  }
                }
              },
              [_vm._v("\n        下一步\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-close",
            on: { click: _vm.handleClose }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.step === 5
      ? _c("div", { staticClass: "guide-step-5" }, [
          _c("div", { staticClass: "map-mask" }),
          _vm._v(" "),
          _c("div", { staticClass: "next-card" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "next-btn", on: { click: _vm.handleClose } },
              [_vm._v("\n        知道了\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-close",
            on: { click: _vm.handleClose }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upgrade-notes-desc" }, [
      _c("p", [_c("span", [_vm._v("全新的控制台操作界面，服务管理更加便捷")])]),
      _vm._v(" "),
      _c("p", [_c("span", [_vm._v("更详尽的业务内容管理，更全面的信息展示")])]),
      _vm._v(" "),
      _c("p", [_c("span", [_vm._v("APPID再无操作系统平台限制，多平台共享")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("服务管理按产品服务划分，点击直"),
      _c("br"),
      _vm._v("接使用，不再需要开通应用了。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("订单管理、工单、消息、个人"),
      _c("br"),
      _vm._v("资料页的入口，搬到这里啦。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("新版本服务管理页面布局直观，操"),
      _c("br"),
      _vm._v("作便捷，内容展示一目了然。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("点击这里的返回按钮，可以返回应"),
      _c("br"),
      _vm._v("用列表。")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c74a822", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c74a822","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Guide/index.vue
// module id = 763
// module chunks = 40